export default __webpack_public_path__ + "static/1_36-e3e2f0cac0b3a32f989e69ac88411952.png";